<script>
import FTextfield from "../input/FTextfield.vue";
import { whereAmIClicked } from "./slider_utils.mjs";

export default {
  props: {
    steps: Array,
    index: Number,
    showStepper: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      cursorSize: 24,
      step: 0,
      stepWidth: 0,
      mouseDown: false,
      value: "",
      sliderWidth: undefined,
      // cursorLeft: undefined,
    };
  },
  computed: {
    cssVars() {
      return {
        "--cursorLeft": this.step * this.stepWidth + this.cursorSize / 2 + "px",
        "--fillWidth": this.step * this.stepWidth + this.cursorSize / 2 + "px",
      };
    },
    sliderElt() {
      return this.$refs.sliderElt;
    },
  },
  mounted: function () {
    this.step = this.index;
    this.value = this.steps[this.step].toString();
    window.addEventListener("mousemove", this.mousemove);
    // window.addEventListener("mousedown", this.mousedown);
    window.addEventListener("mouseup", this.mouseup);
  },
  beforeDestroy: function () {
    window.removeEventListener("mousemove", this.mousemove);
    // window.removeEventListener("mousedown", this.mousedown);
    window.removeEventListener("mouseup", this.mouseup);
  },
  methods: {
    mousemove: function ($event) {
      if (!this.mouseDown && $event.type != "click") return;

      const x = whereAmIClicked(this.sliderElt, $event);
      const progress = x / this.sliderWidth;

      this.step = Math.round(progress * (this.steps.length - 1));
      this.value = this.steps[this.step].toString();
      this.$emit("newindex", this.step);

      // this.cursorLeft = this.step * this.stepWidth + this.cursorSize / 2;
    },
    mousedown: function ($event) {
      this.sliderWidth = this.sliderElt.getBoundingClientRect().width;
      this.mouseDown = true;
    },
    mouseup: function ($event) {
      this.mouseDown = false;
    },
    stepUp: function ($event) {
      var nextStep = this.step + 1;
      if (this.steps[nextStep]) {
        this.step = this.step + 1;
        this.$emit("newindex", this.step);
      }
    },
    stepDown: function ($event) {
      var previousStep = this.step - 1;
      if (this.steps[previousStep]) {
        this.step = this.step - 1;
        this.$emit("newindex", this.step);
      }
    },
    textfieldChange: function ($event) {
      let needle = parseInt($event.target.value);
      let closest = this.steps.reduce((a, b) => {
        return Math.abs(b - needle) < Math.abs(a - needle) ? b : a;
      });
      if (typeof closest !== 'undefined') {
        this.step = this.steps.indexOf(closest);
        this.$emit("newindex", this.step);
      }
    },
  },
  watch: {
    index: function (v) {
      this.step = this.index;
    },
    step: function () {
      setTimeout(() => {
        const width = this.sliderElt.clientWidth - this.cursorSize;

        this.stepWidth = width / (this.steps.length - 1);

        // this.cursorLeft = this.step * this.stepWidth + this.cursorSize / 2;
        this.value = this.steps[this.step].toString();
      });
    },
  },
};
</script>
    
<template>
  <f-field>
    <template v-slot:label><slot name="label"></slot></template>
    <template v-slot:content>
      <div class="f-slider-container">
        <div
          class="f-slider"
          @click="mousemove($event)"
          @mousedown="mousedown"
          :style="cssVars"
          ref="sliderElt"
        >
          <div class="f-container" ref="containerElt">
            <div class="f-background"></div>
            <div class="f-fill"></div>
            <div class="f-cursor" :class="{ 'mouse-down': mouseDown }"></div>
          </div>
        </div>
        <div v-if="showStepper" class="f-stepper">
          <f-textfield
            :input.sync="value"
            type="number"
            @blur="textfieldChange($event)"
          >
            <template #action>
              <div class="f-stepper-actions">
                <f-button type="icon small transparent" @click="stepUp()">
                  <f-icon icon="fa6-angle-up"></f-icon>
                </f-button>
                <f-button type="icon small transparent" @click="stepDown()">
                  <f-icon icon="fa6-angle-down"></f-icon>
                </f-button>
              </div>
            </template>
          </f-textfield>
        </div>
      </div>
    </template>
    <template v-slot:helper><slot name="helper"></slot></template>
  </f-field>
</template>

<style lang="scss">
.f-slider-container {
  display: flex;
  user-select: none;

  // colors:
  .f-background {
    background-color: var(--navigation-a5);
    &:hover {
      background-color: var(--navigation-a10);
    }
    &:active {
      background-color: var(--navigation-a25);
    }
  }
  .f-fill {
    background-color: var(--turquoise);
    &:hover {
      background-color: var(--turquoise-d90);
    }
    &:active {
      background-color: var(--turquoise-d80);
    }
  }
  .f-cursor {
    &:hover::after {
      background-color: var(--blue-a25);
    }
    &:active::after,
    &.mouse-down::after {
      background-color: var(--blue-a75);
    }
  }

  .f-slider {
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    height: 48px;
    cursor: pointer;
    .f-container {
      position: relative;
      flex: 1 1 100%;
      height: 8px;
      border-radius: 4px;

      .f-background {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .f-fill {
        position: absolute;
        width: var(--cursorLeft);
        height: 100%;
        border-radius: 4px;
      }

      .f-cursor {
        width: 24px;
        height: 24px;
        background: #ffffff;
        box-shadow: 0px 4px 16px rgba(22, 22, 21, 0.25);
        border-radius: 16px;
        position: absolute;
        left: var(--cursorLeft);
        top: -8px;
        margin-left: -12px;
        // pointer-events: none;

        &::after {
          content: "";
          display: block;
          height: 12px;
          width: 12px;
          border-radius: 16px;
          position: absolute;
          left: 6px;
          top: 6px;
        }
      }
    }
  }

  .f-stepper {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-radius: 4px;
    margin-left: 16px;
    flex: 0 0 84px;

    .f-right .f-action .f-stepper-actions {
      display: flex;
      flex-direction: column;
      margin-left: auto;
      width: auto;

      .f-button {
        width: 24px;
        height: 16px;
      }
    }
  }
}
.dark-mode {
  .f-slider-container {
    // colors:
    .f-background {
      background-color: var(--blue-a5);
      &:hover {
        background-color: var(--blue-a10);
      }
      &:active {
        background-color: var(--blue-a25);
      }
    }
    .f-fill {
      background-color: var(--primary);
      &:hover {
        background-color: var(--primary-d90);
      }
      &:active {
        background-color: var(--primary-d80);
      }
    }
    .f-cursor {
      &:hover::after {
        background-color: var(--navigation-a25);
      }
      &:active::after,
      &.mouse-down::after {
        background-color: var(--navigation-a75);
      }
    }

    .f-slider {
      .f-container {
        .f-cursor {
          background: #ffffff;
          box-shadow: 0px 4px 16px rgba(22, 22, 21, 0.25);
        }
      }
    }
  }
}
</style>